import { Component, Input, Output, EventEmitter } from "@angular/core";
import { VAIconRegistryService, check, plus } from "@va/core-library/icons";
@Component({
  selector: "app-add-modal-section",
  templateUrl: "./add-modal-section.component.html",
  styleUrls: ["./add-modal-section.component.scss"],
})
export class AddModalSectionComponent {
  @Input() dataToUse: Array<any>;
  @Input() field: string;
  @Input() company: string;
  @Output() addData = new EventEmitter<any>();
  @Input() maxHeight: string;

  constructor(private iconRegistryService: VAIconRegistryService) {
    this.iconRegistryService.registerIcons([plus, check]);
  }

  addTicker(data) {
    this.addData.emit([data, false]);
  }
}
